export const infos = {
  login: {
    title: "宏景云平台-登录",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  register: {
    title: "宏景云平台-注册",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  loginAndbindAccount: {
    title: "宏景云平台-绑定微信",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  home: {
    title: "宏景云平台",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  cooperativePartner: {
    title: "宏景云平台-合作伙伴",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  partnerList: {
    title: "宏景云平台-合作伙伴",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  aboutUs: {
    title: "宏景云平台-关于我们",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  productList: {
    title: "宏景云平台-解决方案",
    desc: "致力于打造中国人才发展生态链，让人尽其才，才尽其用！"
  },
  typicalUsers: {
    title: "宏景云平台-经典实践",
    desc: "总结了人才管理的经典实践，通过互联网技术，与宏景广大的用户进行分享，提升用户管理水平，降低用户总拥成本！"
  },
  // 产品介绍
  personnelOrganization: {
    title: "组织人事",
    desc: "组织人事包括组织管理和人事管理两部分。其中，组织管理包括组织机构、职位体系、汇报关系和能力体系；人事管理包括人事信息、人事异动、人事报表、数据采集、人事合同等。"
  },
  salaryInsurance: {
    title: "薪酬保险",
    desc: "薪酬保险包括薪酬福利和保险管理两大模块。其中，薪酬福利包括薪酬体系、工资总额、薪酬变动、薪酬发放、薪酬分析；保险管理包括保险设置、基数核定、缴费核算、保险分析。"
  },
  performanceManagement: {
    title: "绩效管理",
    desc: "绩效管理包含目标绩效、360考核、事业单位年度考核三大模块。其中目标绩效融合目标管理与绩效考核，支持PDCA闭环管理；360考核适用于年度综合能力评估；事业单位年度考核专为事业单位设计，支持年度评级与评优推先。"
  },
  titleReview: {
    title: "职称评审",
    desc: "宏景云职称评审平台，实现从信息发布、材料申报、同行评议、专家评审、发证和总结分析全流程管理。"
  },
  cadreInformation: {
    title: "干部管理",
    desc: "干部管理涵盖干部的全生命周期管理，包含干部信息、选拔任用、民主测评、民主推荐、干部考核等模块。"
  },
  onlineLearning: {
    title: "人才培养与发展",
    desc: "人才培养与发展包含人才盘点、领导力评估反馈、培训管理、在线学习和在线考试五大模块。"
  },
  talentRecruitment: {
    title: "人才引进",
    desc: "人才地图应用于人才引进、学术交流、项目合作、客座教授和外派培养等多种业务场景。"
  },
  employeeSelfService: {
    title: "员工自助",
    desc: "员工自助包括我的信息、我的申请、我的考勤、我的薪酬、我的绩效、我的职称、我的培训。"
  },
  managerSelfService: {
    title: "经理自助",
    desc: "经理自助包括成员信息、团队薪酬、团队绩效和团队学习。"
  },
  leaderDesktop: {
    title: "领导桌面",
    desc: "领导桌面包括人才数量分析、重要岗位空缺分析和离线掌上查询。"
  },
  // 解决方案
  corePersonnel: {
    title: "核心人力资源管理解决方案",
    desc: "宏景云核心人力资源管理解决方案针对国有企事业单位在人力资源管理过程中的难点和痛点分析，提供了组织管理、人事信息、人事异动、人事合同、人事报表、请假公出、考勤上报、薪酬福利、保险管理、领导桌面和员工自助等业务全流程解决方案。"
  },
  cadreManagement: {
    title: "干部管理解决方案",
    desc: "如何有效地做好干部选拔任用、考核激励、培养发展工作，关系到国有企事业单位健康发展。宏景深入研究国有企事业单位的干部管理政策和需求，打造基于SaaS模式的干部管理平台，实现干部信息、干部盘点、选拔任用、干部考核、干部监督、干部培养、领导桌面等全面管理。"
  },
  solutionTalentDevelopment: {
    title: "人才管理解决方案",
    desc: "宏景云人才管理解决方案深度聚焦国有企事业单位在人力资源管理过程中的难点和痛点，提供覆盖组织人事、薪酬保险、考勤管理、绩效、职称评审、干部管理、人才发展、领导桌面和员工自助等业务的一体化全流程解决方案。"
  },
  fullPerformance: {
    title: "全员绩效管理解决方案",
    desc: "近年来国家陆续出台多项制度办法，强调正向激励考核，突出了考核作为管理的指挥棒作用，绩效管理也是落实三项制度改革的重要抓手。因此，宏景云运用新技术，融合科学的绩效管理思想，实现基于战略、基于过程、基于全员、基于全面、基于社交的绩效管理。"
  },
  assessment360: {
    title: "360考核解决方案",
    desc: "360考核是绩效考核中比较常用的一种方法，国有企事业单位应用广泛，在干部年度考核、半年度考核、任期考核等业务场景中都会使用。360考核解决方案针对国有企事业单位360考核的常见问题及难点进行分析，为企事业单位提供一个强大的、快捷的、全流程业务解决方案。"
  },
  solutionTitleReview: {
    title: "职称评审解决方案",
    desc: "职称评审是我国企事业单位专业技术人员队伍的基本评价制度，宏景云实现了信息发布、职称申报、职称评审、确认公示和总结分析全流程管理，将申报单位、呈报单位、评审单位进行整合，实现职称评审专员、职称申报人、信息审核员、评审专家、单位领导互联互通。"
  },
  peerReview: {
    title: "同行评议解决方案",
    desc: "同行评议是高校职称评审的关键环节，同行评议解决方案针对外送评审业务全过程管理，实现了申报人、信息审核人、送审单位、同行单位、评审专家一体化解决方案。我们提供用户送审和平台送审两种服务模式，满足用户不同管理需求。"
  },
  democraticEvaluation: {
    title: "民主测评解决方案",
    desc: "民主测评是在一定范围内了解干部群众对测评对象评价意见的一种方法，主要应用于干部选拔、转正和年度测评。民主测评解决方案针对目前国有企事业单位常见问题进行分析，阐述民主测评及一报告两评议业务解决方案和给用户带来的价值。"
  },
  democraticRecommendation: {
    title: "民主推荐解决方案",
    desc: "民主推荐是配备领导班子和干部选拔任用的重要活动之一，针对在投票过程中常见的难点问题分析，为国有企事业单位提供一套免费完美的解决方案，该解决方案还适用于竞聘上岗、职称会议评审、评先推优等业务场景。"
  },
  leadershipAssessment: {
    title: "领导力评估解决方案",
    desc: "中层管理者的领导力在很大程度上决定着团队的业绩、氛围和成员的能力发展，高素质的管理者短缺正成为企业发展的瓶颈。领导力评估解决方案借助专业的领导力模型对管理人员进行领导力评估，帮助管理人员解决自我认识问题，持续能力提升。"
  },
  onlineLearningExam: {
    title: "在线学习与考试解决方案",
    desc: "人才培养的重要性毋庸置疑，传统线下模式在组织学习与考试时常面临成本高、效率低、效果难跟踪等难题，宏景云在线学习与考试一体化解决方案，构建以业务为导向、场景化培训模式，显著提升效率，助力企业打造数智化人才培养平台，实现人才培养的降本增效。"
  },
  talentInventory: {
    title: "人才盘点解决方案",
    desc: "人才盘点是实现人与组织战略精准匹配的关键战略性流程。针对企业在人才管理中普遍存在的无人可用、用人失察和结构失调的痛点，宏景云人才盘点解决方案提供了一套从标准构建、数据洞察、多维评估、述职述能、结果校准到结果应用的完整数字化闭环。"
  },
  talentMap: {
    title: "人才地图解决方案",
    desc: "人才是最宝贵的资源，如何快速、精准引进有能力、有经验、懂管理、懂技术的高层次人才，满足组织发展需求？宏景云人才地图解决方案针对国有企事业单位对于高层次人才引进面临的问题，提供有针对性的解决方案。"
  },
  managerTenure: {
    title: "经理层任期制考核解决方案",
    desc: "宏景云经理层任期制与契约化管理数字化解决方案，深度融合先进管理理念与国家政策要求，专为国企场景设计。覆盖了从协议签订、目标制定、过程跟踪、考核评价到结果应用的全生命周期，形成一个完整的、自动化的管理闭环。"
  },
  securityTechnology: {
    title: "技术解决方案",
    desc: "宏景云平台的安全与技术解决方案围绕技术先进性、安全可靠、系统集成等核心目标构建，为企业提供全栈云服务的安全保障。"
  },
}